export default __webpack_public_path__ + "static/media/tablet-home.6d522c7d.jpg";